import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossGrey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.7968 3.60994L12.3825 2.19531L7.99841 6.58073L3.61441 2.19543L2.2002 3.61006L6.5842 7.99537L2.2002 12.3807L3.61441 13.7953L7.99841 9.41L12.3825 13.7954L13.7967 12.3808L9.41263 7.99537L13.7968 3.60994Z",
		fill: "black",
		fillOpacity: .6
	})]
});
const ForwardRef = forwardRef(SvgCrossGrey);
export { ForwardRef as ReactComponent };
